'use client';

import { SignUp } from "@stackframe/stack";

export default function SignUpPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-[#1E4289] mb-2">
            Join RateWDW
          </h1>
          <p className="text-slate-600">
            Create an account to save your ratings and keep scoring WDW
          </p>
        </div>
        <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-8">
          <SignUp />
        </div>
      </div>
    </div>
  );
}

